module.exports = {
  language: 'Portuguese',
  nationalityKay: 'pt-pt',
  personal: {
    purgePopupContent:
      'Desculpe, seus dados de inscrição foram removidos devido à política de segurança, você pode entrar em contato conosco se quiser se inscrever em breve'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Por favor seleccione',
  multiselect: {
    deselect: 'Pressione Enter para remover',
    select: 'Pressione Enter para selecionar',
    selected: 'Selecionado'
  },
  enter: ' Digitar',
  upload_failed: 'Falha no upload, tente novamente',
  due_time: 'Prazo de entrega',
  requirement: 'Requerimento',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Temporariamente indisponível',
  'Coming soon': 'Em breve'
};
